import styled from "styled-components";
import IconContainer from "./IconContainer";

const DangerIconContainer = styled(IconContainer)`
    color: ${props => props.theme.colors.error};
`

export default DangerIconContainer;